<template>
  <v-menu
    v-model="notifications.display"
    :theme="dropdownTheme"
    :close-on-content-click="false"
    location="bottom end"
    transition="scale-transition"
  >
    <template #activator="{ props }">
      <v-btn
        icon
        variant="text"
        class="mx-1"
        size="small"
        v-bind="props"
      >
        <v-badge
          v-if="$store.state.admin && $store.state.admin.unread_notifications"
          :content="$store.state.admin.unread_notifications"
          :model-value="$store.state.admin && ($store.state.admin.unread_notifications > 0)"
          color="red"
          location="top end"
        >
          <v-icon size="small">mdi-bell</v-icon>
        </v-badge>
        <v-icon
          v-else
          size="small"
        >mdi-bell-outline</v-icon>
      </v-btn>
    </template>

    <div
      style="max-height: 300px; overflow-y: auto;"
    >
      <v-card
        rounded="0"
        class="text-default-content"
        color="default-panel"
      >
        <v-list
          class="text-default-content"
          bg-color="default-panel"
        >
          <v-list-item>
            <v-list-item-title>Notifications</v-list-item-title>
            <v-list-item-subtitle>{{ this.$store.state.admin.email }}</v-list-item-subtitle>
            <template #append>
              <v-btn
                v-if="$store.state.admin"
                icon
                variant="text"
                class="mr-4"
                @click.stop="reloadNotifications"
              >
                <v-badge
                  :content="$store.state.admin.unread_notifications"
                  :model-value="$store.state.admin && ($store.state.admin.unread_notifications > 0)"
                  color="red"
                  location="top end"
                >
                  <v-icon
                    v-if="$store.state.admin.unread_notifications"
                  >mdi-bell</v-icon>
                  <v-icon
                    v-else
                  >mdi-bell-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-timeline
          density="compact"
          side="end"
          style="max-width: 400px;"
        >
          <v-timeline-item
            v-for="notification in this.notifications.data"
            :key="notification.id"
            size="x-small"
            :dot-color="getNotificationColor(notification)"
          >
            <v-card
              v-if="notification.type == 'announcement'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Announcement</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div
                v-html="notification.data.message"
              ></div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'linkedin_added'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>LinkedIn Account</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                <base-linkedin-account
                  v-model="notification.data.linkedin"
                ></base-linkedin-account>
                has been added to {{ notification.data.account.name }}.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'linkedin_removed'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>LinkedIn Account</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                <base-linkedin-account
                  v-model="notification.data.linkedin"
                ></base-linkedin-account>
                has been removed from {{ notification.data.account.name }}.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'linkedin_updated'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>LinkedIn Account</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                <base-linkedin-account
                  v-model="notification.data.linkedin"
                ></base-linkedin-account>
                has been updated.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'linkedin_credentials_required'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>LinkedIn Account</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                <base-linkedin-account
                  v-model="notification.data.linkedin"
                ></base-linkedin-account>
                credentials are invalid.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'linkedin_captcha_detected'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>LinkedIn Account</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                <base-linkedin-account
                  v-model="notification.data.linkedin"
                ></base-linkedin-account>
                captcha detected.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'linkedin_pin_detected'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>LinkedIn Account</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                <base-linkedin-account
                  v-model="notification.data.linkedin"
                ></base-linkedin-account>
                PIN required.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'linkedin_pin_submitted'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>LinkedIn Account</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                <base-linkedin-account
                  v-model="notification.data.linkedin"
                ></base-linkedin-account>
                PIN submitted.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'linkedin_status_changed'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>LinkedIn Account</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                <base-linkedin-account
                  v-model="notification.data.linkedin"
                ></base-linkedin-account>
                status changed to {{ notification.data.status }}.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'linkedin_setup_finished'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>LinkedIn Account</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                <base-linkedin-account
                  v-model="notification.data.linkedin"
                ></base-linkedin-account>
                setup finished successfully.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'linkedin_setup_failed'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>LinkedIn Account</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                <base-linkedin-account
                  v-model="notification.data.linkedin"
                ></base-linkedin-account>
                setup failed: {{ notification.data.error }}</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'task_added'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Task <strong>{{ notification.data.task.label }}</strong> has been created.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'task_updated'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Task <strong>{{ notification.data.task.label }}</strong> has been updated.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'task_removed'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Task <strong>{{ notification.data.task.label }}</strong> has been deleted.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'task_assigned'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Task <strong>{{ notification.data.task.label }}</strong> has been assigned to <strong>{{ notification.data.user.name }}</strong>.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'task_expired'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Task <strong>{{ notification.data.task.label }}</strong> has reached its due date at <strong>{{ formatDate(notification.data.task.due_date) }}</strong>.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'task_contact_added'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Contact <strong>{{ notification.data.contact.first_name }} {{ notification.data.contact.last_name }}</strong> has been added to <strong>{{ notification.data.task.label }}</strong>.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'task_contact_removed'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Contact <strong>{{ notification.data.contact.first_name }} {{ notification.data.contact.last_name }}</strong> has been removed from <strong>{{ notification.data.task.label }}</strong>.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'task_company_added'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Company <strong>{{ notification.data.company.name }}</strong> has been added to <strong>{{ notification.data.task.label }}</strong>.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'task_company_removed'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Company <strong>{{ notification.data.company.name }}</strong> has been removed from <strong>{{ notification.data.task.label }}</strong>.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'todo_list_added'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Todo List <strong>{{ notification.data.todo_list.label }}</strong> has been added to <strong>{{ notification.data.task.label }}</strong>.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'todo_list_updated'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Task <strong>{{ notification.data.task.label }}</strong> has been updated.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'todo_list_removed'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Todo List <strong>{{ notification.data.todo_list.label }}</strong> has been removed from <strong>{{ notification.data.task.label }}</strong>.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'todo_added'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                New todo item <strong>{{ notification.data.todo.label }}</strong> has been added to <strong>{{ notification.data.todo_list.label }}</strong> of the <strong>{{ notification.data.task.label }}</strong>.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'todo_updated'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Task <strong>{{ notification.data.task.label }}</strong> has been updated.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'todo_removed'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Todo <strong>{{ notification.data.todo.label }}</strong> has been removed from <strong>{{ notification.data.todo_list.label }}</strong> of <strong>{{ notification.data.task.label }}</strong>.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'todo_completed'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Task</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                Completed <strong>{{ notification.data.todo.label }}</strong> in <strong>{{ notification.data.todo_list.label }}</strong> of <strong>{{ notification.data.task.label }}</strong>.</div>
            </v-card>
            <v-card
              v-else-if="notification.type == 'workflow_contact_alert'"
              class="pa-3 ml-4"
              variant="outlined"
              rounded="sm"
              :color="getNotificationColor(notification)"
            >
              <div>
                <h5>
                  <span>Workflow</span>
                </h5>
                <div class="text-subtitle-2">{{ notification.created_at }}</div>
              </div>
              <div>
                <strong>{{ notification.data.workflow.name }}</strong> contact <strong>{{ notification.data.contact.first_name }} {{ notification.data.contact.last_name }}</strong> has pushed alert.</div>
                <v-card
                  v-if="notification.data.message"
                  variant="outlined"
                  rounded="sm"
                  color="indigo"
                  class="ma-1 pa-1"
                >
                  <div>{{ notification.data.message }}</div>
                </v-card>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-card>
      <div
        v-intersect="notificationsInfiniteScrolling"
        style="min-height: 1px;"
      ></div>
    </div>
  </v-menu>
</template>

<script>
import NotificationsApi from "@/api/NotificationsApi";
import NotificationSfx from '@/assets/notification.wav';

export default {
  name: 'MainNavNotifications',

  data: () => ({
    notifications: {
      display: false,
      data: [],
      page: 0,
      last_page: 0,
      total: 0,
      loading: false,
    },
    interval: null,
    lastUnreadCount: 0,
  }),

  computed: {
    dropdownTheme() {
      return this.$store.state.isDarkMode ? 'dark' : 'light';
    },
  },

  mounted() {
    this.interval = setInterval(() => {
      if (this.$store.state.admin && (this.$store.state.admin.unread_notifications > this.lastUnreadCount)) {
        this.lastUnreadCount = this.$store.state.admin.unread_notifications;
        this.playSoundAlert();
      }
    }, 5000);
  },

  beforeUnmount() {
    if (this.interval) clearInterval(this.interval);
  },

  watch: {
    'notifications.display': function (open) {
      if (open) {
        this.reloadNotifications();
      }
    },
  },

  methods: {

    loadData: function () {
      this.$store.dispatch('loadAdmin');
    },

    updateUnreadCount: function (count) {
      if (!this.$store.state.admin) return;
      this.lastUnreadCount = count;
      this.$store.commit('setAdmin', Object.assign({}, this.$store.state.admin, {
        unread_notifications: count,
      }));
    },

    loadNotifications: function () {
      if (this.notifications.loading) return;
      if ((this.notifications.page > 0) && (this.notifications.last_page > 0) && (this.notifications.page >= this.notifications.last_page)) return;
      this.notifications.loading = true;
      this.notifications.page += 1;
      var page = this.notifications.page;
      NotificationsApi.getNotifications(page, 5).then(response => {
        if (page == 1) this.notifications.data = [];
        this.notifications.data = this.notifications.data.concat(response.data.data);
        this.notifications.total = response.data.meta.total;
        this.notifications.last_page = response.data.meta.last_page;
        this.notifications.loading = false;
        if (response.data.meta && (response.data.meta.unread_notifications !== undefined)) {
          this.updateUnreadCount(response.data.meta.unread_notifications);
        }
        this.loadData();
      }).catch(() => {
        this.notifications.loading = false;
      });
    },

    reloadNotifications: function () {
      this.notifications.loading = false;
      this.notifications.page = 0;
      this.notifications.last_page = 0;
      this.notifications.total = 0;
      this.notifications.data = [];
      if (this.$store.state.admin) {
        this.$store.commit('setAdmin', Object.assign({}, this.$store.state.admin, {
          unread_notifications: 0,
        }));
      }
      this.loadNotifications();
    },

    notificationsInfiniteScrolling: function (isIntersecting /* , entries, observer */) {
      if (!isIntersecting) return;
      if (this.notifications.loading) return;
      this.loadNotifications();
    },

    getNotificationColor: function (notification) {
      if (notification.type == 'announcement') {
        return 'red';
      } else if (notification.type == 'linkedin_credentials_required') {
        return 'warning';
      } else if (notification.type == 'linkedin_captcha_detected') {
        return 'warning';
      } else if (notification.type == 'linkedin_pin_detected') {
        return 'warning';
      } else if (notification.type == 'linkedin_pin_submitted') {
        return 'primary';
      } else if (notification.type.startsWith('linkedin')) {
        return 'blue';
      } else if (notification.type.startsWith('workflow')) {
        return 'indigo';
      } else if ((notification.type.startsWith('task')) ||
                (notification.type.startsWith('todo'))) {
        return 'teal';
      }
    },

    playSoundAlert: function () {
      (async () => {
        const audio = new Audio(NotificationSfx);
        audio.play();
      })();
    },

    formatDate: function (date) {
      let formattedDate = new Date(date);
      return formattedDate.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      })
    },
  },
};
</script>
